import type { ReactElement } from 'react';
import {
    Drawer,
    DrawerBody,
    DrawerContent,
    DrawerHeader,
    DrawerOverlay,
    Flex,
    PopoverBody,
    Popover as PopoverChakra,
    PopoverContent,
    PopoverHeader,
    PopoverTrigger,
    Portal,
} from '@chakra-ui/react';
import { ConditionalRender } from '../../components/conditionally-render/ConditionalRender';

interface Props {
    id: string;
    triggerElement: React.ReactNode;
    headerElement: React.ReactNode;
    bodyElement: React.ReactNode;
    isOpen: boolean;
    onOpen: () => void;
    onClose: () => void;
}

export const Popover = ({
    id,
    triggerElement,
    headerElement,
    bodyElement,
    isOpen,
    onOpen,
    onClose,
}: Props): ReactElement => (
    <>
        <ConditionalRender visibility={{ base: false, sm: true }}>
            <PopoverChakra
                isOpen={isOpen}
                onOpen={onOpen}
                onClose={onClose}
                trigger="hover"
                placement="bottom-start"
            >
                <PopoverTrigger>{triggerElement}</PopoverTrigger>

                <Portal>
                    <PopoverContent data-testid={`${id}-popover`}>
                        <PopoverHeader data-testid={`${id}-header`}>{headerElement}</PopoverHeader>

                        <PopoverBody data-testid={`${id}-body`}>{bodyElement}</PopoverBody>
                    </PopoverContent>
                </Portal>
            </PopoverChakra>
        </ConditionalRender>

        <ConditionalRender visibility={{ base: true, sm: false }}>
            <Flex onClick={onOpen}>{triggerElement}</Flex>

            <Drawer isOpen={isOpen} onClose={onClose} variant="popover" placement="bottom">
                <DrawerOverlay />

                <DrawerContent data-testid={`${id}-drawer`}>
                    <DrawerHeader data-testid={`${id}-header`}>{headerElement}</DrawerHeader>

                    <DrawerBody data-testid={`${id}-body`}>{bodyElement}</DrawerBody>
                </DrawerContent>
            </Drawer>
        </ConditionalRender>
    </>
);
